import Vue from "vue";

export const roles = [

    {
        text: "Administrador",
        value: "admin",
        color: "black",
        dark: true
    },
    {
        text: "Cliente",
        value: "user",
        color: "blue",
        dark: true
    },
    {
        text: "Parceiro",
        value: "partner",
        color: "green",
        dark: true
    },
]

export const permissions = [
    {
        id: 'DEFAULT',
        name: "Website"
    },
    {
        id: 'SECRETARY_ASSISTANT',
        name: "Assistente de secretária"
    },
    {
        id: 'ARTICLE_ASSISTANT',
        name: "Assistente de artigos"
    },
    {
        id: 'SOCIAL_NETWORK_ASSISTANT',
        name: "Assistente de redes sociais"
    },
    {
        id: 'CONVERSATION_ANALYSIS',
        name: "Análise de atendimentos"
    },
    {
        id: 'GEO_SEO_PRESENCE',
        name: "Presença GEO e SEO"
    }
]

const roleLabels = roles.reduce((acc, role) => {
    acc[role.value] = role.text;
    return acc;
}, {});

export const $user = {
    permissions,
    roles,
    roleLabels
}

Vue.prototype.$user = $user;
